import { ModalRouteService } from './../../../services/modal-route.service';
import { SapiEntity } from './../../../services/sapi.service';
import { Component, Input, Output, EventEmitter, ElementRef, OnInit } from '@angular/core';
import { NgForm, UntypedFormGroup } from '@angular/forms';
import { AuthenticationService } from './../../../services/authentication.service';
import { EntityConfiguration } from '../abstract-details.component';

@Component({
	selector: 'bb-actions-bar',
	templateUrl: './bb-actions-bar.component.html',
	styleUrls: ['./bb-actions-bar.component.scss']
})

export class BbActionsBarComponent implements OnInit {
	@Input() formGroup: UntypedFormGroup;
	@Input() form: NgForm;
	@Input() entity: SapiEntity;
	@Input() entityConfiguration: EntityConfiguration;
	@Input() hideDelete: boolean;
	@Input() saveDisabled: boolean;
	@Input() previewLink: string;
	@Input() trackPreviewWindow: boolean;
	@Input() overrideAllowSave = false; // overwrite hasPermisson put

	@Output() onPublish = new EventEmitter<void>();
	@Output() onPreview = new EventEmitter<void>();
	@Output() onSave = new EventEmitter<void>();
	@Output() onCancel = new EventEmitter<void>();
	@Output() onDelete = new EventEmitter<void>();
	@Output() onUndo = new EventEmitter<void>();
	@Output() onRedo = new EventEmitter<void>();

	putRight = false;
	deleteRight = false;
	rootRights = false;
	inModal = false;
	previewWindow: Window;

	constructor(
		protected authenticationService: AuthenticationService,
		public modalRouteService: ModalRouteService,
		private elRef: ElementRef
	) {
		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);
		this.authenticationService.hasPermission('delete').subscribe(hasRight => this.deleteRight = hasRight);
		this.authenticationService.hasPermission('root').subscribe(hasRight => this.rootRights = hasRight);
	}

	ngOnInit() {
		if (this.formGroup) {
			this.formGroup.valueChanges
				.subscribe((valuesChanged: any) => {
					this.entity = { ...this.entity, ...valuesChanged };
				});
		}
		if (this.form && this.form.form) {
			this.formGroup = this.form.form;
		}
		this.inModal = this.elRef.nativeElement.closest('.route-modal');
	}

	resetForm() {
	}

	onPreviewClick(url, ev: Event) {
		if (this.trackPreviewWindow) {
			try {
				ev.preventDefault();
				if (!this.previewWindow?.window?.window) {
					this.previewWindow = window.open(url, 'actionBarPreviewWindow');
				} else {
					this.previewWindow.window.location.href = url;
					this.previewWindow.focus();
					const win = this.previewWindow as any;
					if (win?.updateOvpPreviewWin) {
						win.updateOvpPreviewWin(true);
					}
				}
			} catch(e) {
				this.previewWindow = window.open(url, 'actionBarPreviewWindow');
			}
		}
		this.onPreview.emit(url);
	}

	onPublishClick() {
		this.onPublish.emit();
	}

	onSaveClick() {
		this.onSave.emit();
	}

	onCancelClick() {
		this.onCancel.emit();
	}

	onDeleteClick() {
		this.onDelete.emit();
	}

	onUndoClick() {
		this.onUndo.emit();
	}

	onRedoClick() {
		this.onRedo.emit();
	}
}
